<script setup>
  import { useLocalePath } from '#i18n'

  const { menuTop } = useMainMenu()
  const localePath = useLocalePath()

  const sponsorshipMenu = ref()
  const sponsorshipOpen = ref(false)

  const getPopover = () => {
    const val = sponsorshipMenu.value
    return Array.isArray(val) ? val[0] : val
  }

  const toggleSponsorship = (event) => {
    sponsorshipOpen.value = !sponsorshipOpen.value
    getPopover()?.toggle(event)
  }
</script>

<template>
  <nav class="bg-sky-950 font-body h-8">
    <div class="container flex justify-between items-center">
      <NuxtLink class="font-light text-xs text-white" :to="localePath({ name: 'index' })">
        {{ $t('menu.MenuTop.uia') }}
      </NuxtLink>
      <ul class="text-xs flex justify-end font-light text-white h-8">
        <li v-for="page in menuTop" :key="page.title" class="flex items-center h-8">
          <!-- Single-item entry: simple link -->
          <Button v-if="page.items.length === 1" as-child pt:root="!h-8 !py-0">
            <NuxtLink
              class="text-xs text-white hover:text-sky-100 flex px-3 h-8 items-center"
              :to="localePath({ name: page.items[0].path, params: page.items[0].params || {} })"
            >
              {{ page.title }}
            </NuxtLink>
          </Button>

          <!-- Multi-item entry: dropdown -->
          <template v-else>
            <Button
              type="button"
              variant="link"
              aria-haspopup="true"
              pt:root="!text-xs !text-white hover:!text-sky-100 !flex !items-center !gap-1 !h-8 !py-0 !px-3"
              @click="toggleSponsorship"
            >
              {{ page.title }}
              <font-awesome
                class="text-[10px] fa-fw transition-transform duration-200"
                :class="{ 'rotate-180': sponsorshipOpen }"
                :icon="['fas', 'chevron-down']"
              />
            </Button>
            <Popover
              ref="sponsorshipMenu"
              pt:root="!z-[1200]"
              pt:content="!p-0 !min-w-[200px] !bg-white !shadow-xl !border !border-slate-100"
              @hide="sponsorshipOpen = false"
            >
              <NuxtLink
                v-for="item in page.items"
                :key="item.title"
                :to="localePath({ name: item.path }) + (item.hash || '')"
                class="block w-full py-2 px-4 text-sm text-slate-700 hover:bg-sky-50 hover:text-sky-800 transition-colors duration-200"
                @click="getPopover()?.hide()"
              >
                {{ item.title }}
              </NuxtLink>
            </Popover>
          </template>
        </li>
        <li class="flex items-center h-8">
          <Button as-child pt:root="!h-8 !py-0">
            <NuxtLink
              class="text-xs text-white hover:text-sky-100 flex px-3 h-8 items-center"
              :to="localePath({ name: 'contact' })"
            >
              <span>{{ $t('footer.contact') }}</span>
            </NuxtLink>
          </Button>
        </li>
        <li class="border-l border-white/50 h-8 flex items-center">
          <span class="flex h-8">
            <MenuAuth />
          </span>
        </li>
        <li class="border-l border-white/50 h-8 flex items-center">
          <MenuLanguage />
        </li>
      </ul>
    </div>
  </nav>
</template>
